module.exports = __webpack_public_path__ + "img/active.b0ee3d15.svg";